module.exports = __webpack_public_path__ + "img/call_taxi_success.7e021af3.png";